export default __webpack_public_path__ + "static/media/shellhub.6bcc4743.svg";